import { render } from "./PatientBulkReassign.vue?vue&type=template&id=2c775adc&ts=true"
import script from "./PatientBulkReassign.ts?vue&type=script&lang=ts&external"
export * from "./PatientBulkReassign.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__